<template>
  <div>
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Danh sách công việc của AFS</h1>
      <div class="btn-group float-right">
        <DraggableTable
          :naming="$router.name"
          v-model="fieldsTable"
          @change="filterTable = $event"
        />
        <button
          class="font-medium f12 btn btn-outline-secondary"
          data-toggle="tooltip"
          data-placement="top"
          data-original-title="Xuất Excel"
          @click="exportExcel"
        >
          <i class="bx bx-download"></i><span>&nbsp;</span>Xuất Excel
        </button>
      </div>
    </div>
    <div class="card p-10 pt-15 b-t-1-869fb229">
      <div class="card-header m-b-10">
        <form class="box-search" @submit="submitForm">
          <div class="form-group">
            <input
              type="text"
              v-model.trim="search.keySearch"
              class="form-control f12 hc-37 text-search"
              placeholder="Từ khoá"
            />
          </div>
          <div class="form-group">
            <DateRangePicker
              class="w-100"
              :ranges="false"
              @update="transformDate()"
              v-model="dateRange"
              :locale-data="Config.localeData"
            >
              <template v-slot:input="picker">
                <label
                  v-if="picker.startDate && picker.endDate"
                  style="min-width: 13.5em"
                  class="text-center font-size-12 pt-1"
                >
                  {{ picker.startDate | formatDate }} -
                  {{ picker.endDate | formatDate }}
                </label>
                <label v-else style="min-width: 13.5em" class="font-size-12 time-placeholder">
                  TG hoàn thành
                </label>
              </template>
            </DateRangePicker>
          </div>
          <div class="form-group">
            <Select2MultipleControl
              :settings="{ placeholder: 'Tên Sale', multiple: false }"
              v-model="search.saleIds"
              :options="dataManager"
            >
            </Select2MultipleControl>
          </div>
          <div class="form-group">
            <Select2 v-model="search.regionId" :options="dataConfigRegion" placeholder="Vùng" />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.status"
              :options="[
                {
                  id: 'NO_APPROVE',
                  text: 'Chưa duyệt',
                },
                {
                  id: 'APPROVE',
                  text: 'Đã duyệt',
                },
                {
                  id: 'REJECT',
                  text: 'Từ chối',
                },
              ]"
              placeholder="Trạng thái"
            />
          </div>
          <div class="form-group form-group-action">
            <button
              class="btn btn-primary hc-37 mr-2 pt-2"
              data-toggle="tooltip"
              data-placement="top"
              title="Lọc"
              @click="submitForm"
            >
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Lọc
            </button>
            <button
              type="button"
              class="btn btn-outline-light hc-37 mr-2 pt-2"
              data-toggle="tooltip"
              data-placement="top"
              title="Bỏ lọc"
              @click="removeForm"
            >
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Bỏ lọc
            </button>
          </div>
        </form>
      </div>
      <div class="card-body">
        <div class="tab-content" id="nav-tabContent">
          <div class="p-10">
            Tổng: <strong class="text-primary">{{ pagination.total }}</strong>
            <b-table
              :busy.sync="tbLoading"
              sticky-header
              responsive
              hover
              :items="lists"
              :fields="filterTable"
              :fixed="true"
              :bordered="true"
            >
              <template #table-busy>
                <div class="text-center my-2">
                  <b-spinner class="align-middle"></b-spinner>
                </div>
              </template>
              <template #cell(index)="data">
                {{ getIndex(data.index) }}
              </template>
              <template #cell(merchantName)="data">
                <p>{{ data.item.merchantName }}</p>
                <p>{{ data.item.merchantEmail }}</p>
              </template>
              <template #cell(operationType)="data">
                <span
                  class="badge"
                  :class="[data.item.operationType ? data.item.operationType : 'WAITING']"
                >
                  {{ data.item.operationType | transformData(Config.statusJob) }}
                </span>
                <div v-if="data.item.operationType && data.item.operationType === 'REJECT'">
                  <p v-if="data.item.rejectNote" class="form-control-plaintext f12">
                    Lý do: &nbsp; {{ data.item.rejectNote }}
                  </p>
                </div>
              </template>
              <template #cell(mcRegionId)="data">
                {{ data.item.mcRegionId | transformData(dataConfigRegion) }}
              </template>
              <template #cell(saleName)="data">
                <p>{{ data.item.saleName }}</p>
              </template>
              <template #cell(approveInfo)="data">
                <p>{{ data.item.approveName }}</p>
              </template>
              <template #cell(createdTime)="data">
                <p><b>Tạo:</b> {{ data.item.createdTime | formatDate('HH:mm, DD/MM/YYYY') }}</p>
                <p>
                  <b>Hoàn thành:</b>
                  {{ data.item.timeComplete | formatDate('HH:mm, DD/MM/YYYY') }}
                </p>
                <p><b>Duyệt:</b> {{ data.item.approveAt | formatDate('HH:mm, DD/MM/YYYY') }}</p>
              </template>
              <template #cell(action)="data">
                <b-dropdown class="text-center" variant="outline-light">
                  <b-dropdown-item @click="detail(data.item.id)" class="dropdown-item"
                    ><span>&nbsp;</span>Chi tiết
                  </b-dropdown-item>
                </b-dropdown>
              </template>
            </b-table>
          </div>
        </div>
        <div class="pagination-bottom">
          <b-pagination
            v-model="search.page"
            :total-rows="pagination.total"
            :per-page="search.limit"
            class="fl-right mr-2"
          ></b-pagination>
        </div>
      </div>
    </div>
    <VueLoadingOverlay :active.sync="loading" :is-full-page="true"> </VueLoadingOverlay>
  </div>
</template>

<script>
  import { StaffService } from '@/services/staff.service'
  import { mapGetters } from 'vuex'
  import prepareQueryParamsMixin from '../../mixins/prepareQueryParamsMixin'
  import 'vue-simple-suggest/dist/styles.css'
  import Config from '@/thirdParty/config'
  import moment from 'moment'
  import { GPDKKDService } from '@/services/gpdkkd.service'
  import cloneDeep from 'lodash/cloneDeep'
  const fieldsTable = [
    { key: 'index', label: 'STT', class: 'text-center' },
    { key: 'merchantName', label: 'MC' },
    { key: 'mcRegionId', label: 'Vùng' },
    { key: 'saleName', label: 'Sale' },
    { key: 'approveInfo', label: 'Người duyệt' },
    { key: 'createdTime', label: 'TG' },
    { key: 'operationType', label: 'Trạng thái' },
    { key: 'action', label: 'Thao tác', fixIndex: 999, class: 'text-center' },
  ]
  export default {
    name: 'gpdkkd-afs',
    mixins: [prepareQueryParamsMixin],
    data() {
      return {
        Config,
        fieldsTable,
        filterTable: fieldsTable,
        lists: [],
        loading: false,
        tbLoading: false,
        dataUser: JSON.parse(localStorage.getItem('userData')),
        dataManager: [],
        dataConfigRegion: [],
        search: {
          limit: 20,
          page: 1,
        },
        pagination: {
          total: 0,
        },
        dateRange: {
          startDate: null,
          endDate: null,
        },
      }
    },
    watch: {
      'search.page': function () {
        this.$router.replace({
          query: this.useInUrlQueryPropList,
        })
        this.fetchData()
      },
    },
    created() {
      this.getRegions()
      this.fetchSuperiors()
      this.fetchData()
    },
    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
      useInUrlQueryPropList() {
        return this.prepareQueryParamsMixin({
          limit: this.search.limit,
          page: this.search.page,
        })
      },
    },
    filters: {
      transformData(data, dataConfig) {
        const dataReturn = dataConfig.filter(e => e.id === data)
        if (dataReturn.length === 0) {
          return ''
        }
        return dataReturn[0].text
      },
    },
    methods: {
      async getRegions() {
        const data = await StaffService.getRegions()
        if (data.data.length > 0) {
          this.dataConfigRegion = data.data.map(e => {
            return {
              id: e.id,
              text: e.name,
            }
          })
          this.dataConfigRegion.unshift({ id: '0', text: 'Tất cả' })
        }
      },
      detail(id) {
        const routeData = this.$router.resolve({
          path: `/gpdkkd/afs/${id}`,
        })
        window.open(routeData.href, '_blank')
      },
      async fetchSuperiors() {
        try {
          const data = await StaffService.getStaffByIdSuperior({
            userId: JSON.parse(localStorage.getItem('userData')).userId,
          })
          const dat = data.data.map(e => {
            return { id: e.userId, text: e.name }
          })
          this.dataManager = [{ id: '0', text: 'Tất cả' }, ...dat]
        } catch (e) {
          console.error(e)
        }
      },
      transformDate() {
        this.search.fromTimeComplete = moment(this.dateRange.startDate)
          .startOf('day')
          .add(7, 'hours')
          .valueOf()
        this.search.toTimeComplete = moment(this.dateRange.endDate)
          .endOf('day')
          .add(7, 'hours')
          .valueOf()
      },
      async submitForm(event) {
        event.preventDefault()
        this.search.page = 1
        this.fetchData()
      },
      async removeForm() {
        this.search = {
          limit: 20,
          page: 1,
        }
        this.dateRange = {
          startDate: null,
          endDate: null,
        }
        this.selected = []
        await this.fetchData()
      },
      async fetchData() {
        try {
          this.tbLoading = true
          if (this.search.saleIds === '0') delete this.search.saleIds
          const params = cloneDeep(this.search)
          params.pageIndex = params.page
          params.pageSize = params.limit
          if (params.saleIds) params.saleIds = [params.saleIds]
          const response = await GPDKKDService.fetchAfs(params)
          if (response.code === 1000) {
            this.lists = response.data
            this.pagination.total = response.totalPage.total
          } else {
            this.showFailMx(response.message)
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.tbLoading = false
        }
      },
      async exportExcel() {
        try {
          if (this.search.saleIds === '0') delete this.search.saleIds
          const params = cloneDeep(this.search)
          params.pageIndex = 1
          params.pageSize = 100000
          if (params.saleIds) params.saleIds = [params.saleIds]
          this.loading = true
          await GPDKKDService.exportExcelAfs(params)
        } catch (error) {
          console.log(error)
        } finally {
          this.loading = false
        }
      },
    },
  }
</script>

<style>
  .time-placeholder,
  .text-search::placeholder {
    color: #999 !important;
  }

  .card .card-header .dropdown .dropdown-toggle {
    font-size: 16px !important;
    margin-top: -12px !important;
  }
</style>
